/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useLazyQuery } from '@apollo/client';

export const FETCH_SUBSCRIPTIO_BY_PRODUCT_TAG_GQL = gql`
query FetchProductSubscriptionByProductTag($fetchByProductTagRequest: FetchProductTagSubscriptionRequest!) {
fetchProductSubscriptionByProductTag(fetchByProductTagRequest: $fetchByProductTagRequest) {
  products
  productNames
}
}`
export const useGetSubscriptionByProductTag = () => {
  const [getProductSubscriptionDetails, productSubscriptionDetail] = useLazyQuery(FETCH_SUBSCRIPTIO_BY_PRODUCT_TAG_GQL);
  return { getProductSubscriptionDetails, productSubscriptionDetail };
}

